__turbopack_context__.v({
  "badge": "DFyfZa_badge",
  "collectionAtlantis": "DFyfZa_collectionAtlantis",
  "collectionBoutique": "DFyfZa_collectionBoutique",
  "collectionChild": "DFyfZa_collectionChild",
  "collectionCulinary": "DFyfZa_collectionCulinary",
  "collectionCycling": "DFyfZa_collectionCycling",
  "collectionDefault": "DFyfZa_collectionDefault",
  "collectionExcellent": "DFyfZa_collectionExcellent",
  "collectionFamfun": "DFyfZa_collectionFamfun",
  "collectionNewestDiscoveries": "DFyfZa_collectionNewestDiscoveries",
  "collectionPearls": "DFyfZa_collectionPearls",
  "collectionPrimavera": "DFyfZa_collectionPrimavera",
  "collectionRomantic": "DFyfZa_collectionRomantic",
  "collectionSecrets": "DFyfZa_collectionSecrets",
  "collectionSelections": "DFyfZa_collectionSelections",
  "collectionTotallySnow": "DFyfZa_collectionTotallySnow",
  "collectionVillages": "DFyfZa_collectionVillages",
  "collectionXperience": "DFyfZa_collectionXperience",
  "content": "DFyfZa_content",
  "description": "DFyfZa_description",
  "imageWrapper": "DFyfZa_imageWrapper",
  "label": "DFyfZa_label",
  "uspItem": "DFyfZa_uspItem",
  "uspsWrapper": "DFyfZa_uspsWrapper",
  "wrapper": "DFyfZa_wrapper",
});
